import { Heading, HeadingProps } from "@chakra-ui/react";
import React, { FC } from "react";

export const Logo: FC<HeadingProps> = (props) => {
  return <Heading {...props}>Rockit🚀</Heading>;
};
